<template>
<popup title="Manage product variants" class="manage-variants-popup" @close="$emit('close')">
	<template v-slot:content>
		<div style="position: relative;min-height: 200px;">
			<Loading v-if="loading" />
			<table v-else>
				<thead>
				<tr>
					<th></th>
					<th>Variant name</th>
					<th>
						<span style="display: flex;justify-content: center;">
							Price
							<info-icon>When empty it will be the same price as the main product.</info-icon>
						</span>
					</th>
					<th>Image</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="row in rows" :key="row.id">
					<td > <input type="checkbox" :checked="row.selected" /> </td>
					<td class="name"> {{[row.option1,row.option2,row.option3].filter(Boolean).join(' / ')}} </td>
					<td class="price">
						<input-field type="number" v-model.number="row.price" small select-all
						             placeholder="Default price" flat  prepend="$" />
					</td>
					<td class="image">
						<div class="img-wrapper" @click="currentRow=row;popupOpen=true">
							<v-button class="remove" v-if="row.image_url"
							          @click.stop="row.image_url = null"
							          :icon="require('@/assets/img/delete_icon.svg')" slim flat
							          v-tippy content="Remove image" />
							<span class="change">Change...</span>
							<img v-if="row.image_url" alt="" :src="imgUrl(row.image_url)" />
							<img  v-else alt="" src="//img.funnelish.com/default/default-image.svg?height=60" />
						</div>
					</td>
				</tr>
				</tbody>
			</table>
			<select-image-popup v-if="popupOpen" :funnel-id="funnelId"
			                    @imageChoosed="currentRow ? currentRow.image_url=$event.url : ''"
			                    @closePopup="currentRow={},popupOpen=false"  />
		</div>
	</template>
	<template v-slot:actions>
		<v-button label="Save changes" :loading="saving" @click="save"  />
		<v-button label="Cancel" border @click="$emit('close')" />
	</template>
</popup>
</template>

<script>
import Popup from "@/components/base/popup";
import VButton from "@/components/base/v-button";
import InputField from "@/components/base/input-field";
import PriceField from "@/components/base/price-field";
import InfoIcon from "@/components/base/info-icon";
import SelectImagePopup from "@/modules/page-editor/src/components/popups/SelectImagePopup";
import API from '@/api';
import Loading from "@/components/Loading";

export default {
	name: "manage-variants",
	mixins:[API],
	components: {Loading, SelectImagePopup, InfoIcon, PriceField, InputField, VButton, Popup},
	props:['funnelId', 'product'],
	data(){
		return {
			loading: false,
			saving: false,
			currentRow: {},
			popupOpen: false,
			rows: [
				{id:'1',title:'Red / M', price:null, image_url:null, selected: false},
				{id:'2',title:'Red / S', price:23.99, image_url:null},
				{id:'3',title:'Red / L', price:12.97, image_url:null},
				{id:'4',title:'Blue / XL', price:120.97, image_url:null},
				{id:'5',title:'Green / XXL', price:133.97, image_url:null},
			],
		}
	},
	computed:{
	},
	methods: {
		imgUrl(url){
			return url.replace('images.funnelish.com', 'img.funnelish.com') + '?height=60'
		},
		async init(){
			try {
				this.loading = true;

				let data = await this.api.wsteps.getOptions(this.product.id);
				this.rows = data;
				console.log(data);
			} catch (e) {
				this.$error(e)
			} finally {
				this.loading = false;
			}
		},
		async save(){
			try {
				this.saving = true;

				this.rows.forEach(r => {
					r.product_id = this.product.id;
					r.funnel_id = this.product.funnel_id;
					r.step_id = this.product.step_id;
				})

				let res = await this.api.wsteps.saveOptions(this.product.id, this.rows);
				if (res.status!=="ok") throw res;
				this.$info(res, "Your variant options were saved successfully.");
				this.$emit('close');
			} catch (e) {
				this.$error(e)
			} finally {
				this.saving = false;
			}
		},
	},
	created() {
		this.init();
	}
}
</script>
<style lang="scss" >
.manage-variants-popup {
	.popup > .content {
		padding: 0;
	}
	.popup_header {
		margin: 0;
	}
	.img-wrapper{
		.remove{
			&:hover {
				background: rgb(255 190 190) !important;
			}
			svg {
				margin: 0;
				path {
					fill: red;
				}
			}
		}
	}
}
</style>
<style lang="scss" scoped>
.manage-variants-popup {
table {
	border-spacing: 0;
	thead {
		th {
			//border-top: 1px solid silver;
			border-bottom: 1px solid $light-grey;
			background: $light-grey;
			padding: 5px;
			position: sticky;
			top: 0;
			z-index: 6;
		}
	}
	tr{
	td {
		border-left: 1px solid $light-grey;
		border-bottom: 1px solid $light-grey;
		min-width: 40px;
		margin: 0;
		padding: 5px;
		&:last-child {
			border-right: 1px solid $light-grey;
		}

		input[type="checkbox"] {
			appearance: auto;
		}
		&.name {
			width: 100%;
		}
		&.price {
			min-width: 150px;
		}
		&.image {
			min-width: 100px;
			display: flex;
			justify-content: center;
		}
	}
	}
} // table
	.img-wrapper {
		border: 1px dashed $sharp-blue;
		border-radius: 3px;
		width: 60px;
		height: 60px;
		line-height: 60px;
		cursor: pointer;
		position: relative;

		.button {
			display: flex;
			width: 80px;
			height: 80px;
			flex: 0;
		}
		.remove {
			background: transparent;
			position: absolute;
			top: 2px;
			width: auto;
			height: auto;
			right: 2px;
			padding: 4px;
			z-index: 5;
			margin-top: 0;
		}
		.change {
			display: inline-block;
			position: absolute;
			width: 100%;
			height: 100%;
			text-align: center;
			z-index: 2;
			color: whitesmoke;
			transition: all .2s ease-in-out;
			opacity: 0;
			font-size: 10px;
		}
		&:after {
			transition: all .2s ease-in-out;
			background: rgba(0, 0, 0, 0.35);
			content: '';
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			opacity: 0;
		}
		&:hover {
			border: 1px solid rgba(0, 0, 0, 0.35);
			.change {
				opacity: 1;
			}
			&:after {
				opacity: 1;
			}
		}
		img {
			height: 100%;
			width: 100%;
			object-fit: scale-down;
		}
	} // .img-wrapper
}
</style>
